// extracted by mini-css-extract-plugin
module.exports = {"btn_hover":"PRTPBanner_btn_hover__W_k5_","btn_color":"PRTPBanner_btn_color__bn7bo","banner_font":"PRTPBanner_banner_font__QNL0g","animSize":"PRTPBanner_animSize__RGb6u"};